export default {
  grade: {
    id: 'bo_sellers-opportunities-inventory-filters-grade',
    defaultMessage: 'Grade',
  },
  categoryId: {
    id: 'bo_sellers-opportunities-inventory-filters-category_id',
    defaultMessage: 'Item category',
  },
  productSearch: {
    id: 'bo_sellers-opportunities-inventory-filters-product_search',
    defaultMessage: 'Search by product',
  },
  currency: {
    id: 'bo_sellers-opportunities-inventory-filters-currency',
    defaultMessage: 'Currency',
  },
  applyFilters: {
    id: 'bo_sellers-opportunities-inventory-filters-apply_filters',
    defaultMessage: 'Apply filters',
  },
  resetFilters: {
    id: 'bo_sellers-opportunities-inventory-filters-reset_filters',
    defaultMessage: 'Reset filters',
  },
  filter: {
    id: 'bo_sellers-opportunities-inventory-filters-filter',
    defaultMessage: 'Filter',
  },
  viewResults: {
    id: 'bo_sellers-opportunities-inventory-filters-view_results',
    defaultMessage: 'View results',
  },
  competition: {
    id: 'bo_sellers.opportunities.inventory.filters.competition',
    defaultMessage: 'Competition',
  },
}
